import {
  ADMINFINANCIAL_DATA_GET,
  ADMINFINANCIAL_DATA_SUCCESS
} from "./actionTypes"

export const adminFinancialDataGet = (query, history) => { 
  return {
    type: ADMINFINANCIAL_DATA_GET,
    payload: { query, history },
  }
}

export const adminFinancialDataSuccess = data => {
  // alert("data")
  return {
    type: ADMINFINANCIAL_DATA_SUCCESS,
    payload: data,
  }
}